module.exports = __webpack_public_path__ + "img/download-keystore-grey.2cd87b2a.svg";